module.exports = __webpack_public_path__ + "static/gtm-01b0aa86f1496fab9a200bd3792dac9d.png";